import { SESSION_HEADER, ensureSessionCapability } from '../core/session/session-identity.js'

/** The customer saw this reply. Store it for the admin transcript without opening a turn. */
export async function rememberSeenAssistantReply(
  sessionId: string,
  userText: string,
  assistantText: string,
): Promise<void> {
  const id = sessionId.trim()
  const user = userText.trim()
  const assistant = assistantText.trim()
  if (!id || !user || !assistant) return
  try {
    await ensureSessionCapability(id)
    await fetch('/api/session', {
      method: 'PATCH',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        [SESSION_HEADER]: id,
      },
      body: JSON.stringify({
        sessionId: id,
        seenReply: { userText: user, assistantText: assistant },
      }),
    })
  } catch {
    // The Live reply is already on screen. A missed admin copy can retry next turn.
  }
}
